/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class AccountRoleGrid extends SiteEntityGrid<AccountRoleRow, any> {
        protected getColumnsKey() { return 'Data.AccountRole'; }
        protected getDialogType() { return AccountRoleDialog; }
        protected getIdProperty() { return AccountRoleRow.idProperty; }
        protected getLocalTextPrefix() { return AccountRoleRow.localTextPrefix; }
        protected getService() { return AccountRoleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}